import {h, Component, Fragment} from "preact";
import * as I from "../utils/icons.jsx";


export function BlankSeparator() {
	return <div class="hidden cl-blank-separator h-3 bg-zinc-900"></div>;
}

export function MenuRow({children}) {
	return <div class="cl-menu-row flex h-10 items-center justify-between rounded-t-lg bg-slate-100 text-slate-950">
	  {children}
	</div>
}

export function MenuTitleLabel({children}) {
	return <div class="cl-menu-ttl-label text-base uppercase p-4">{children}</div>
}

export function MenuTitle({children}) {
	return <MenuRow>
	  <MenuTitleLabel>{children}</MenuTitleLabel>
	</MenuRow>
}

export function MenuCollapseBtnHolder({children}) {
	return <div class="cl-menu-coll-btn-holder h-full w-9 border-l border-l-zinc-950 flex items-center justify-center">{children}</div>
}

export function MenuTitleCenteredLabel({children}) {
	return <div class="cl-menu-ttl-left-label w-full text-left text-base flex items-center pl-8 uppercase bg-slate-100 text-slate-950">{children}</div>
}

export function MenuTitleCentered({children}) {
	return <div class="cl-menu-ttl-center flex h-10 items-center bg-slate-100 text-slate-950">
	  <MenuTitleCenteredLabel>{children}</MenuTitleCenteredLabel>
	</div>
}

export function SearchEventBodyContainer({children, ref}) {
	return <div class="cl-srch-evt-body-cont flex h-12 flex-col items-center justify-center rounded-b-lg bg-slate-100 text-zinc-500" ref={ref}>
		{children}
	</div>
}

export function SearchDescContainer({children}) {
	return <div class="cl-srch-desc-cont flex grow items-center px-2 text-center text-sm leading-4">
		{children}
	</div>
}

export function SearchBarContainer({children}) {
	return <div class="cl-srch-bar-cont h-10 w-full flex-none p-2">{children}</div>
}

export function SearchInput({children}) {
	return <div class="cl-srch-input h-full w-full rounded-xl bg-slate-300 text-slate-950 relative flex items-center justify-center">{children}</div>
}

export function SearchContentWrapper({children, ref, parentRect}) {
	return <div class="cl-srch-cont-wrap fixed overflow-hidden pt-1 pl-1 w-96 z-50" style={`left:${parentRect.left}px;top:${parentRect.top+parentRect.height}px`} ref={ref}>
		{children}
	</div>
}
export function SearchPopupEventsHolder({children}) {
	return <div class="cl-srch-popup-evt-hold h-52 overflow-y-auto scrollbar-fancy">{children}</div>
}

export function SearchEvent() {
	return <div>
		<MenuTitle>Search Event</MenuTitle>
		<SearchEventBodyContainer>
		  <SearchDescContainer>Insert the events name or at least one team in the form below</SearchDescContainer>
		  <SearchBarContainer><SearchInput /></SearchBarContainer>
		</SearchEventBodyContainer>
	</div>
}

export function TimeFilterButtonContainer({children}) {
	return <div class="cl-tmflt-btn-cont flex h-5 justify-between border-b border-b-slate-300">{children}</div>;
}

export function TimeFilterButton({children, onClick, active = false}) {
	return active ? <div class="cl-tmflt-btn w-1/6 border-r border-r-slate-400 text-center text-xs text-slate-950 bg-kobaaccent-400 cursor-pointer">{children}</div>
		  : <div onClick={onClick} class="cl-tmflt-btn w-1/6 border-r border-r-slate-400 bg-slate-300 text-center text-xs text-slate-950 cursor-pointer hover:bg-kobaaccent-400">{children}</div>
}

export function TimeFilter() {
	return <div>
		<MenuTitle>Quick Filter</MenuTitle>
		<TimeFilterButtonContainer>
		  <TimeFilterButton active={true}>All</TimeFilterButton>
		  <TimeFilterButton>All</TimeFilterButton>
		  <TimeFilterButton>All</TimeFilterButton>
		  <TimeFilterButton>All</TimeFilterButton>
		  <TimeFilterButton>All</TimeFilterButton>
		  <TimeFilterButton>All</TimeFilterButton>
		</TimeFilterButtonContainer>
	</div>
}

export function CircleSeparator() {
	return <div class="cl-circle-sep flex w-6 flex-none items-center justify-center"><div class="h-1.5 w-1.5 rounded-full bg-white"></div></div>;
}
export function CircleSeparatorW2() {
	return <div class="hidden cl-circle-sep-w2 flex w-9 flex-none items-center justify-center pl-3"><div class="h-1.5 w-1.5 rounded-full bg-white"></div></div>;
}
export function SportFlagIcon({sport}) {
	return <div class="cl-sportflag-icon relative w-8 p-1">{sport && <span class={"sporticon sp_"+sport.id.replace('/sport/', '')}></span>}</div>;
}
export function RegionFlag({category}) {
	return <div class="cl-regionflag-icon flex w-12 items-center justify-center">
		{category && <RegionFlagIcon category={category} />}
	</div>;
}
export function RegionFlagSmall({category}) {
	return <div class="cl-regionflag-icon-sm flex w-8 items-center justify-center">
		{category && <RegionFlagIcon category={category} />}
	</div>;
}
export function RegionFlagIcon({category}) {
	return <span class={"cl-regionflag-icon rectangleFlag rectangleFlags_"+category.label.toLowerCase().replace(/ /g, '')}></span>
}
export function LeagueFlagIcon({category, tournament}) {
	return <div class={"cl-leagueflag-icon league-"+(category.label+tournament.label).toLowerCase().replace(/ /g, '')} style="width:22px;height:22px"></div>
}
export function TournamentFlagIcon({category, tournament}) {
	return <div class="cl-tournamentflag-icon w-12 flex justify-end">{(category && tournament) && <LeagueFlagIcon category={category} tournament={tournament} />}</div>;
}
export function LeagueNameLabel({children}) {
	return <div class="cl-league-name-lbl w-full min-w-0 grow truncate text-sm">{children}</div>
}

export function TopLeagueButton({children, onClick}) {
	return <div class="cl-topleague-btn flex h-8 items-center border-t border-t-slate-300 bg-slate-100 text-slate-950 cursor-pointer hover:text-kobaaccent-600" onClick={onClick}>
		{children}
	</div>
}

export function TopLeagues() {
	return <div>
		<MenuTitleCentered>Top Leagues</MenuTitleCentered>
		<div>
		  <TopLeagueButton>
			<TournamentFlagIcon />
		    <CircleSeparator />
			<LeagueNameLabel>League Name</LeagueNameLabel>
			<SportFlagIcon />
		  </TopLeagueButton>
		  <TopLeagueButton>
			<TournamentFlagIcon />
		    <CircleSeparator />
			<LeagueNameLabel>League Name</LeagueNameLabel>
			<SportFlagIcon />
		  </TopLeagueButton>
		  <TopLeagueButton>
			<TournamentFlagIcon />
		    <CircleSeparator />
			<LeagueNameLabel>League Name</LeagueNameLabel>
			<SportFlagIcon />
		  </TopLeagueButton>
		</div>
	</div>
}



export function SportButton({children, active = false, onClick}) {
	return !active
		? <div class="cl-sport-btn flex h-8 px-3 items-center border-b border-b-slate-300 bg-slate-100 text-slate-950 uppercase cursor-pointer hover:bg-slate-200" onClick={onClick}>{children}</div>
		: <div class="cl-sport-btn flex h-8 px-3 items-center border-b border-b-slate-300 bg-slate-100 text-slate-950 uppercase cursor-pointer hover:bg-slate-200" onClick={onClick}>{children}</div>
}
export function MenuMatchCounter({children}) {
	return <div class="cl-menu-matchount flex w-12 items-center justify-end"><div class="text-xs px-1 pb-0.5">{children}</div></div>
}

export function CategoryButton({children, onClick}) {
	return <div class="cl-category-button px-2 flex h-8 items-center border-b border-b-slate-300 bg-slate-200 text-slate-950 cursor-pointer hover:bg-slate-100" onClick={onClick}>{children}</div>
}

export function ToggleCartet({active}) {
	return <I.UpArrowIcon class={"h-4 px-2 transition-transform "+(active ? '' : 'rotate-180')} />;
}

export function TournamentButton({children, active, onClick}) {
	return !active ? <div class="cl-tournament-button flex px-3 h-8 items-center border-b border-b-slate-300 bg-slate-100 text-slate-950 cursor-pointer hover:bg-slate-200" onClick={onClick}>{children}</div>
		: <div class="cl-tournament-button flex px-3 h-8 items-center border-b border-b-slate-300 bg-slate-200 text-slate-950 cursor-pointer hover:bg-slate-200" onClick={onClick}>{children}</div>
}
export function CircleSeparatorW3({active}) {
	return !active ? <div class="hidden cl-circle-sep-w3 flex w-11 flex-none items-center justify-center pl-5"><div class="h-1.5 w-1.5 rounded-full bg-white"></div></div>
		: <div class="hidden cl-circle-sep-w3 flex w-11 flex-none items-center justify-center pl-5"><div class="h-1.5 w-1.5 rounded-full bg-kobaaccent-500"></div></div>;
}
export function TournamentLabel({children}) {
	return <div class="cl-tournament-lbl w-full min-w-0 bottom-0 grow truncate pb-0.5 pl-1 text-sm">{children}</div>
}
export function TournamentPlusSign({children}) {
	return <div class="cl-tournament-plus relative bottom-0 w-5 text-center font-bold text-slate-800">+</div>;
}

export function SecondarySportsMenuTitle({children}) {
	return <div class="cl-sec-sport-menu-ttl mt-3 rounded-t-lg flex h-10 items-center bg-kobaaccent-400">
	  <div class="w-full pl-4 text-left text-base uppercase text-slate-950">{children}</div>
	</div>
}

export function PrematchMenu() {
	return <div>
	  <div>
		  <SportButton>
			<MenuMatchCounter>1000</MenuMatchCounter>
			<CircleSeparator />
			<LeagueNameLabel>Sport Name</LeagueNameLabel>
			<SportFlagIcon />
		  </SportButton>
	  </div>
	  <div>
		<SportButton active={true}>
		  <MenuMatchCounter>1000</MenuMatchCounter>
		  <CircleSeparator />
		  <LeagueNameLabel>Sport Name</LeagueNameLabel>
		  <SportFlagIcon />
		</SportButton>
		<div>
			<div>
			  <CategoryButton>
				<CircleSeparatorW2 />
				<RegionFlag />
				<LeagueNameLabel>Region Name</LeagueNameLabel>
				<ToggleCartet active={true} />
			  </CategoryButton>
			  <div>
				<TournamentButton>
				  <CircleSeparatorW3 />
				  <TournamentLabel>Tournament</TournamentLabel>
				  <TournamentPlusSign />
				</TournamentButton>
				<TournamentButton active={true}>
				  <CircleSeparatorW3 active={true} />
				  <TournamentLabel>Tournament</TournamentLabel>
				  <TournamentPlusSign />
				</TournamentButton>
				<TournamentButton>
				  <CircleSeparatorW3 />
				  <TournamentLabel>Tournament</TournamentLabel>
				  <TournamentPlusSign />
				</TournamentButton>
			  </div>
			</div>
		</div>
	  </div>
	  <SportButton>
		<MenuMatchCounter>1000</MenuMatchCounter>
		<CircleSeparator />
		<LeagueNameLabel>Sport Name</LeagueNameLabel>
		<SportFlagIcon />
	  </SportButton>
	</div>
}

export function EsportsMenu() {
	return <div>
		<SecondarySportsMenuTitle>E-Sports</SecondarySportsMenuTitle>
		<div>
		  <div>
			  <SportButton>
				<MenuMatchCounter>1000</MenuMatchCounter>
				<CircleSeparator />
				<LeagueNameLabel>Sport Name</LeagueNameLabel>
				<SportFlagIcon />
			  </SportButton>
		  </div>
		  <div>
			  <SportButton>
				<MenuMatchCounter>1000</MenuMatchCounter>
				<CircleSeparator />
				<LeagueNameLabel>Sport Name</LeagueNameLabel>
				<SportFlagIcon />
			  </SportButton>
		  </div>
		  <div>
			  <SportButton>
				<MenuMatchCounter>1000</MenuMatchCounter>
				<CircleSeparator />
				<LeagueNameLabel>Sport Name</LeagueNameLabel>
				<SportFlagIcon />
			  </SportButton>
		  </div>
		</div>
	</div>
}


export function BetServicesContent({children}) {
	return <div class="cl-srvces-content flex h-16 items-center justify-around rounded-b-lg bg-slate-100 text-slate-950">{children}</div>
}
export function BetServicesCell({children, onClick}) {
	return <div class="cl-srvces-cell py-2 text-center text-sm flex flex-col items-center cursor-pointer hover:text-kobaaccent-500" onClick={onClick}>{children}</div>
}
export function BetServicesIcon({children}) {
	return <div class="cl-srvces-icon mx-auto h-6 w-4 border"></div>
}


export function BetServices() {
	return <div>
		<SecondarySportsMenuTitle>Bet Services</SecondarySportsMenuTitle>
		<BetServicesContent>
		  <BetServicesCell>
			<BetServicesIcon />
			<div>Live Score</div>
		  </BetServicesCell>
		  <BetServicesCell>
			<BetServicesIcon />
			<div>Live Score</div>
		  </BetServicesCell>
		  <BetServicesCell>
			<BetServicesIcon />
			<div>Live Score</div>
		  </BetServicesCell>
		</BetServicesContent>
	</div>
}
